export default __webpack_public_path__ + "static/media/bannerpromo_CS-HS_intermx_330x330.60d57fe0.webp";